import { CompletionLengthEnum } from '../../../api/ai/enums/completion-length.enum';
import { BriefingCoverageCuratorDisplayElementApiModel } from '../../../api/briefings/model/briefing-coverage-curator-display-element-api.model';
import { MentionSourceApiTypesEnum, mentionSourceApiTypesEnumToMonitoringSeriesTypeEnum } from '../../../api/mentions/enum/mention-source-api-types.enum';
import { DisplayElementWithSearchCriteriaModel } from '../../../Monitor/Briefings/models/display-element-with-search-criteria.model';
import { MonitoringSeriesTypeEnum } from '../../../Monitor/Shared/enums/monitoring-series-type.enum';
import { CoverageInsights } from '../../../Monitor/Shared/models/coverage-insights.model';
import { MentionSearchModel } from '../../../Monitor/Shared/models/mention-search.model';
import { MonitoringBackEndDataSourceModel } from '../../../Monitor/Shared/models/monitoring-back-end-data-source.model';
import { AiAnalysisTypes } from '../../Mentions/enums/ai-analysis-types.enum';
import { CuratorStyle } from './curator-style.model';
import { DisplayElementModel } from './display-element.model';

export class CuratorDisplayElement extends DisplayElementModel implements DisplayElementWithSearchCriteriaModel {
    readonly dateRangeAllowed: boolean = true;

    declare styles: CuratorStyle;
    filterMentionSearchModel: MentionSearchModel;
    initialSourceMentionSearchModel: MentionSearchModel;
    // Filter search criteriaId
    searchCriteriaId: number;
    backendDataSource: MonitoringBackEndDataSourceModel;
    sourceType: MentionSourceApiTypesEnum = MentionSourceApiTypesEnum.ALL_SAVED_COVERAGE;
    bulkAnalysisMessage: CoverageInsights;
    generateOnSend: boolean;
    hasGeneratedContent: boolean;
    useSearchDateFilter: boolean;

    constructor(
        styles?: any,
        apiModel?: BriefingCoverageCuratorDisplayElementApiModel
    ) {
        super();
        this.isBoundToGlobalStyles = true;
        this.styles = new CuratorStyle(styles);
        if (apiModel) {
            if (apiModel.bulkAnalysisMessage) {
                this.bulkAnalysisMessage = new CoverageInsights({bulkAnalysisMessage: apiModel.bulkAnalysisMessage});
            }

            this.generateOnSend = apiModel.generateOnSend;
            this.hasGeneratedContent = !!apiModel.originalBlocks;
            this.useSearchDateFilter = apiModel.useSearchDateFilter;

            if (apiModel.searches.length) {
                const search = apiModel.searches[0];
                this.sourceType = search.sourceType;
                this.backendDataSource = new MonitoringBackEndDataSourceModel(
                    mentionSourceApiTypesEnumToMonitoringSeriesTypeEnum.get(search.sourceType),
                    search.searchCriteriaId
                );

                this.searchCriteriaId = search.filterSearchCriteriaId;
            }
        } else {
            this.bulkAnalysisMessage = new CoverageInsights();
            this.bulkAnalysisMessage.aiAnalysisType = AiAnalysisTypes.COLLECTION_TOP_MENTIONS;
            this.bulkAnalysisMessage.setLengthOptionByValue(CompletionLengthEnum.SHORT);
            this.bulkAnalysisMessage.numberKeyMessages = 3;
            this.generateOnSend = false;
        }

        if (!this.backendDataSource) {
            this.backendDataSource = new MonitoringBackEndDataSourceModel(MonitoringSeriesTypeEnum.allSavedCoverage);
        }
    }

    canRender(): boolean {
        return true;
    }

    clone(): CuratorDisplayElement {
        const clone = new CuratorDisplayElement(this.styles);
        clone.displayType = this.displayType;
        clone.backendDataSource = this.backendDataSource.clone();
        clone.sourceType = this.sourceType;
        clone.searchCriteriaId = this.searchCriteriaId;
        clone.generateOnSend = this.generateOnSend;
        clone.bulkAnalysisMessage = this.bulkAnalysisMessage.clone();
        clone.hasGeneratedContent = this.hasGeneratedContent;
        clone.useSearchDateFilter = this.useSearchDateFilter;
        clone.initialSourceMentionSearchModel = this.initialSourceMentionSearchModel?.clone();
        return clone;
    }

    onUpdate(): boolean {
        return false;
    }

    isEqual(other: CuratorDisplayElement): boolean {
        if (!this.styles.equals(other.styles, true)) {
            return false;
        }

        if (!this.backendDataSource.equals(other.backendDataSource, false)) {
            return false;
        }

        if (this.isBoundToGlobalStyles !== other.isBoundToGlobalStyles) {
            return false;
        }

        if (this.sourceType !== other.sourceType) {
            return false;
        }

        if (this.bulkAnalysisMessage && !this.bulkAnalysisMessage.equals(other.bulkAnalysisMessage)) {
            return false;
        }

        if (this.searchCriteriaId !== other.searchCriteriaId) {
            return false;
        }

        if (this.generateOnSend !== other.generateOnSend) {
            return false;
        }

        if (this.hasGeneratedContent !== other.hasGeneratedContent) {
            return false;
        }

        if (this.useSearchDateFilter !== other.useSearchDateFilter) {
            return false;
        }

        return true;
    }

    setSearchCriteria(searchCriteria: MentionSearchModel) {
        this.filterMentionSearchModel = searchCriteria;
        this.backendDataSource.filterSearchCriteria = this.filterMentionSearchModel.searchCriteria;
    }

    getSearchCriteria(): MentionSearchModel {
        if (!this.filterMentionSearchModel) {
            this.filterMentionSearchModel = new MentionSearchModel();
        }
        this.filterMentionSearchModel.searchCriteria = this.backendDataSource.filterSearchCriteria;

        return this.filterMentionSearchModel;
    }

    setInitialSourceSearchCriteria(searchCriteria: MentionSearchModel) {
        this.initialSourceMentionSearchModel = searchCriteria;
    }
}
